import React from "react";
import "./UnifiedAccessSection.css";

function UnifiedAccessSection() {
  return (
    <section className="unified-access-section section-padding">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Content */}
          <div className="col-lg-6">
            <div className="unified-content">

              <h2 className="unified-heading">
                Simplify Operations with
                <span className="title-blue"> Unified Access</span>
              </h2>

              <p className="unified-description">
                Leading travel agencies choose Sabre for one simple reason —
                one connection, one platform, all the content.
                <br />
                Sabre unites the world’s travel content in one cloud-native
                system, letting agencies easily search, sell, and service
                everything their travelers need.
              </p>

            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-6">
            <div className="unified-image-wrapper">
              <img
                src="/assets/why-tns-card3.svg"
                alt="Unified Access"
                className="unified-image"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default UnifiedAccessSection;